import React, {useEffect, useState} from "react";
import {Box, Typography, Snackbar} from "@material-ui/core";
import {
    useMsal,
} from "@azure/msal-react";
import {useHistory} from "react-router-dom";
import {useUserContext} from "../../context/UserContext";
import axiosInstance from "../../api";
import {Alert} from "@material-ui/lab";
import {getSnackBarMessage, setSnackBarMessage} from "../../utils/sessionUtils";

const response = {fmapRole: "FMAP_ADMIN"};

function FmapHome() {
    const {instance, accounts} = useMsal();
    const {user, dispatch} = useUserContext();
    const history = useHistory();
    const [snackbarMessage, setSnackbarMessage] = useState(getSnackBarMessage());
    useEffect(() => {
        const fetchRole = async () => {
            console.log("in FMAPHOME", window.location);
            let fmapRole = null;
            if (accounts.length > 0) {
                const extension_IGAId = accounts[0].idTokenClaims.IGAId;
                fmapRole = await getFmapRole(extension_IGAId, accounts);
                console.log("Fmap Role", fmapRole);
            }
            updateUserDetails(fmapRole, accounts);
        };
        fetchRole();
    }, [accounts]);

    const getFmapRole = async (extension_IGAId, accounts) => {
        let fmapRole = "";
        dispatchSetSession(accounts, null, false);

        await axiosInstance
            .get(`admin/getFmapRole/${extension_IGAId}`)
            .then((result) => {
                console.log("Fmap Roles", result);
                fmapRole = result;
            })
            .catch((err) => {
                console.log("Error", err.message);
                fmapRole = "";
                // dispatchSetSession(accounts, null, true);
                instance.logoutRedirect();
                setSnackBarMessage("You don't have a valid fmap role");
                dispatchSetSession(accounts, null, true);
            });
        if (fmapRole === "") {
            instance.logoutRedirect();
            setSnackBarMessage("You don't have a valid fmap role");
            dispatchSetSession(accounts, null, true);
        }
        return fmapRole;
    };

    function dispatchSetSession(accounts, fmapRole, setToDefault) {
        dispatch({
            type: "SET_SESSION",
            user: {
                firstName: setToDefault ? null : accounts[0].idTokenClaims.first_name,
                lastName: setToDefault ? null : accounts[0].idTokenClaims.last_name,
                hasSysAccess: setToDefault ? null : "yes",
                username: setToDefault ? null : accounts[0].idTokenClaims.preferred_username,
                cagId: setToDefault ? null : accounts[0].idTokenClaims.IGAId,
                fmapRole: setToDefault ? null : fmapRole ? fmapRole.appRole.roleCode : null,
                userId: setToDefault ? null : accounts[0].idTokenClaims.IGAId,
                exp: setToDefault ? null : accounts[0].idTokenClaims.exp,
                personId: setToDefault ? null : (fmapRole ? fmapRole.fmapLogin.personId : null),
                agentId: setToDefault ? null : (fmapRole ? fmapRole.fmapLogin.agentId : null),
                locked: setToDefault ? null : (fmapRole ? fmapRole.fmapLogin.locked: ""),
                sessionToken:  setToDefault ? null : accounts[0].idToken,
            },
        });
    }

    const updateUserDetails = (fmapRole, accounts) => {
        if (
            accounts.length > 0 &&
            fmapRole &&
            fmapRole.appRole &&
            accounts[0].idToken
        ) {
            dispatchSetSession(accounts, fmapRole, false);

            if (fmapRole.appRole.roleCode === "FMAP_ADMIN" || fmapRole.appRole.roleCode === "FMAP_CC_USER") {
                history.push("/agentSearch");
            } else if (fmapRole.appRole.roleCode === "FMAP_AGENT") {
                history.push("/agent-dashboard");
            }
        } else if (accounts.length === 0) {
            dispatch({
                type: "SET_SESSION",
                user: {
                    firstName: null,
                    lastName: null,
                    hasSysAccess: null,
                    username: null,
                    cagId: null,
                    fmapRole: null,
                    userId: null,
                    exp: null,
                    personId: null,
                    agentId: null,
                    locked: null,
                    sessionToken: null,
                },
            });
        }
    };

    const handleSnackBarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbarMessage('');
        setSnackBarMessage('');
    };

    return (
        <Box m={6}>
            <Snackbar
                open={snackbarMessage && snackbarMessage !== ''}
                autoHideDuration={6000}
                onClose={handleSnackBarClose}
            >
                <Alert variant="filled" onClose={handleSnackBarClose} severity="error">
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <Typography variant="h5" gutterBottom align="left">
                <b>Florida Market Assistance Plan (FMAP) Overview</b>
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                <br/>
                <br/>
                The Florida Market Assistance Plan (FMAP) Online Referral Program was
                designed to assist consumers with finding property and casualty
                insurance coverage in the state of Florida. Through this program,
                consumer requests for coverage can be matched with licensed agents who
                may be able to make an offer of coverage through an authorized, private
                market insurer.
                <br/>
                <br/>
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                Note: FMAP referrals must be placed with admitted market carriers.
                Agents are prohibited from placing these leads with Citizens Property
                Insurance Corporation or surplus lines carriers.
                <br/>
                <br/>
            </Typography>
            <Typography variant="h5" gutterBottom align="left">
                Consumer
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                Following registration, series of questions regarding the property
                seeking coverage. The FMAP online program will match the record
                (containing property details you submitted) with licensed Florida agents
                and insurers. The agent and/or insurer will then call or email to
                determine eligibility and provide an offer, where applicable. Access to
                update record(s) is available at any time using the User ID and password
                supplied during registration.
                <br/>
                <br/>
            </Typography>
            <Typography variant="h5" gutterBottom align="left">
                Agents
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                Once registration is approved, will be able to access FMAP's online
                program to locate consumers that match carrier(s) specific eligibility
                requirements. Can search the FMAP database real-time or use the
                program's automated search feature to notify when consumer requests
                match specific search criteria. Access to update record(s) will be
                available at any time using the User ID and password supplied during
                registration.
                <br/>
                <br/>
            </Typography>
        </Box>
    );
}

export default FmapHome;
